import Vue from 'vue'

export function saveFile(filename, blob) {
  
    // get downloadable url from the blob
    const blobUrl = URL.createObjectURL(blob);
  
    // create temp link element
    let link = document.createElement("a");
    link.download = filename;
    link.href = blobUrl;
  
    // use the link to invoke a download
    document.body.appendChild(link);
    link.click();
  
    // remove the link
    setTimeout(() => {
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
      link = null;
    }, 0);
  }

export const arrayTobject = (items, key = 'createdAt', it = 'id') => {
    var result = {};
    for (var i = 0; i < items.length; i++) {
    result[i] = items[i];
    }
    return result;
};

export const getProps = (obj, props) => {
    const prop = props.shift();
    if (!obj[prop] || !props.length) {
        return obj[prop]
    }//item.find(obj => obj.id === id)
    return getProps(obj[prop], props)
}; //getProp(state, ['foo', 'bar', 'baz']) => true ||

export const asignPre = (obj, id, value) => {
    for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
            const element = obj[key];
            if(element.id = id){
                obj[key].prescriptions = value;
            }
        }
    }
};

export const setProps = (obj, props, value) => {
    const prop = props.shift();
    if (!obj[prop]) Vue.set(obj, prop, {}); //Object.assign(obj[prop], value);
    if (!props.length) {
        obj[prop] = (value && typeof value === 'object' && !Array.isArray(value)) ? {...obj[prop], ...value} : value;
        return;
    }
    setProps(obj[prop], props, value)
}; //setProp(state, ['foo', 'bar', 'baz'], true)

export const delProps = (obj, props) => {
    const prop = props.shift();
    if (!obj[prop]) return;
    if (!props.length) {
        Vue.delete(obj, prop);
        return;
    }
    delProps(obj[prop], props)
};

export function normalizeRelations(data, fields) {
    return {
        ...data,
        ...fields.reduce((prev, field) => ({
            ...prev,
            [field]: Array.isArray(data[field])
                ? data[field].map(x => x.id)
                : data[field].id,
        }), {}),
    };
}

export function resolveRelations(data, fields, rootGetters) {
    return {
        ...data,
        ...fields.reduce((prev, field) => ({
            ...prev,
            [field]: Array.isArray(data[field])
                ? data[field].map(x => rootGetters[`${field}/find`](x))
                : rootGetters[`${field}/find`](data[field]),
        }), {}),
    };
}

export function lazyLoaderView(name) {
    return () => import(`@/pages/${name}.vue`)
}

export function lazyLoaderComponent(name) {
    return () => import(`@/components/${name}.vue`);
}

export function lazyGuardView(name) {
    return {template: '<router-view/>', name};
}

export function lazyLoaderModule(mod) {
    return mod.default || mod;
}